import { createSlice } from '@reduxjs/toolkit';
import { graphqlApi } from '../api'

const initialState = {
    data: []
}

const transform = (data) => {

    if (data?.results && data?.results.length > 0) {

        let newData = {
            results: []
        };
        if (typeof data.results === 'string') {
            newData.results = JSON.parse(data.results);
        }
        else {
            newData = {
                ...data,
                results: data.results
            }
        }

        newData.columns = data.columns || [];

        // Helper function to format date strings
        const formatDate = (value) => {
            const date = new Date(value);
            if (isNaN(date.getTime())) return value; // Return original if not a valid date
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        };

        // Helper function to check if a string looks like a date
        const isDateString = (value) => {
            if (typeof value !== 'string') return false;
            // Check for common date patterns (ISO dates, timestamps, etc.)
            const dateRegex = /^\d{4}-\d{2}-\d{2}|^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}|^\d{13}$/;
            return dateRegex.test(value) && !isNaN(new Date(value).getTime());
        };

        // Transform each result item
        newData.results = newData.results.map((item, index) => {
            const transformedItem = { ...item, id: index + 1 };
            
            // Transform each property in the item
            Object.keys(transformedItem).forEach(key => {
                const value = transformedItem[key];
                
                // Handle dates - format if it's a date string ; hanldes at least 'acceptanceFeePaidDate'
                // TODO Formatted differently than rest of dates; should we move this to queryResultsTransformers?
                if (isDateString(value)) {
                    transformedItem[key] = formatDate(value);
                }
            });
            
            return transformedItem;
        });

        newData.totalCount = data.totalCount;

        return newData;
    }

    return data;
}

const searchSlice = createSlice({
    name: 'search-page',
    initialState,
    reducers: {
        clear: (state) => {
            return [];
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            graphqlApi.endpoints.personSearch.matchFulfilled,
            (state, { payload }) => {
                return transform(payload);
            }
        )
        builder.addMatcher(
            graphqlApi.endpoints.searchForAllData.matchFulfilled,
            (state, { payload }) => {
                return transform(payload);
            }
        )
    }
});

export const selectSearchData = (state) => state.searchSlice
export const { clear } = searchSlice.actions;

export default searchSlice.reducer;